<template>
  <main class="col-md-9 ms-sm-auto col-lg-10 p-0">
    <div class="bg-card p-4 m-3" style="min-height: 70vh">
      <h5 class="text-blue-primary fw-bold pb-2">XARCADE COOKIE POLICY</h5>
      <hr class="border-theme" />
      <p class="pt-2 text-gray-text">
        XARCADE SOLUTIONS SDN. BHD. (“Xarcade” or “we“) uses cookies on our
        website, xarcade.io (the “Website”), to distinguish you from other
        users. This helps us to provide you with a good experience when you
        browse our Website and also allows us to improve it.
      </p>
      <p class="pt-2 text-gray-text">
        By continuing to browse the Website, you are agreeing to our use of
        cookies.
      </p>

      <p class="pt-2 text-gray-text">
        A cookie is a small file of letters and numbers that we store on your
        browser or the hard drive of your computer if you agree. Cookies contain
        information that is transferred to your computer's hard drive.
      </p>

      <p class="pt-2 text-gray-text">We use the following cookies:</p>
      <ul class="text-gray-text">
        <li class="pb-3">
          Strictly necessary cookies. These are cookies that are required for
          the operation of our Website. They include, for example, cookies that
          enable you to log into secure areas of our Website.
        </li>
        <li class="pb-3">
          Analytical/performance cookies. They allow us to recognise and count
          the number of visitors and to see how visitors move around our Website
          when they are using it. This helps us to improve the way our Website
          works, for example, by ensuring that users are finding what they are
          looking for easily.
        </li>

        <li>
          Functionality cookies. These are used to recognise you when you return
          to our Website. This enables us to personalize our content for you,
          greet you by name and remember your preferences (for example, your
          choice of language or region).
        </li>
      </ul>

      <h6 class="py-3 text-white opacity-75">Disabling cookies</h6>
      <p class="text-gray-text">
        You can block cookies by activating the setting on your browser that
        allows you to refuse the setting of all or some cookies. However, if you
        use your browser settings to block all cookies (including essential
        cookies) you may not be able to access all or parts of our Website.
        Thus, it is recommended that you do not disable cookies.
      </p>

      <h6 class="py-3 text-white opacity-75">The cookies we set</h6>
      <p class="text-gray-text">
        If you create an account with us then we will use cookies for the
        management of the signup process and general administration of your
        usage. These cookies will usually be deleted when you log out, however,
        in some cases they may remain afterwards to remember your Website
        preferences when logged out.
      </p>
      <p class="text-gray-text">
        We use cookies when you are logged in so that we can remember this fact.
        This prevents you from having to log in every single time you visit a
        new page. These cookies are typically removed or cleared when you log
        out to ensure that you can only access restricted features and areas
        when logged in.
      </p>
      <p class="text-gray-text">
        The Website may offer newsletter or email subscription services and
        cookies may be used to remember if you are already registered and
        whether to show certain notifications which might only be valid to
        subscribed/unsubscribed users.
      </p>

      <p class="text-gray-text">
        From time to time we may offer user surveys and questionnaires to
        provide you with interesting insights, helpful tools, or to understand
        our user base more accurately. These surveys may use cookies to remember
        who has already taken part in a survey or to provide you with accurate
        results after you change pages.
      </p>

      <p class="text-gray-text">
        When you submit data to our Website or through a form such as those found on contact pages or comment forms, cookies may be set to remember your user details for future correspondence.
      </p>


      <h6 class="py-3 text-white opacity-75">Third Party Cookies</h6>
      <p class="text-gray-text">
      In some special cases, we also use cookies provided by trusted third parties.
Third party analytics are used to track and measure usage of our Website so that we can continue to produce engaging content. These cookies may track things such as how long you spend on our Website or pages you visit which helps us to understand how we can improve it for you.

      </p>
      <p class="text-gray-text">
       From time to time, we test new features and make minor changes to the way that our Website is delivered. When we are still testing new features, these cookies may be used to ensure that you receive a consistent experience whilst on our Website whilst ensuring we understand which updates our users prefer the most.
      </p>
      <p class="text-gray-text">
        As we are offering a service, it’s important for us to understand statistics about how many of the visitors to our Website actually interact with us, as such, this is the type of data that these cookies will track. This is important to you as it means that we can accurately make business predictions which allow us to monitor our advertising and service costs to ensure the best possible price.
      </p>

      <p class="text-gray-text">
       We use adverts to offset the costs of running our Website and provide funding for further development. The advertising cookies linked to users’ online behaviour adopted by our Website are designed to ensure that we provide you with the most relevant adverts where possible by anonymously tracking your interests and presenting related topics that may be of interest.
      </p>

      <p class="text-gray-text">
       We may also use social media buttons and/or plugins on this site that allow you to connect with your social network in a number of ways. For these to work the following social media sites including Facebook, Twitter, Instagram, Telegram, Medium, Reddit and LinkedIn will set cookies through our Website which may be used to enhance your profile on their sites or contribute to the data they hold for various purposes outlined in their respective privacy policies.
      </p>

 <h6 class="py-3 text-white opacity-75">More Information</h6>
      <p class="text-gray-text">
     Hopefully the information provided above has clarified things for you on the reasons for using cookies on our Website. Nevertheless, if you have any doubts about leaving cookies enabled or not, it is usually safer to leave cookies enabled in order to get the best usage and experience from our site.
      </p>
      <p class="text-gray-text">However, if you are still looking for more information please contact us by email at: <a href="mailto:info@xarcade.io">info@xarcade.io</a></p>
      
    </div>
  </main>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: 'viewLegalCookiePolicy',
});
</script>
